import http from "./http";

//#region API endpoints

const login = (data) => {
  return http.post("/login", data);
};
const getActiveQuestionnairesByItemId = (data) => {
  return http.post("/api/get-active-questionnaires-by-itemid", data);
};
const getActiveQuestionnairesByItemCode = (data) => {
  return http.post("/api/get-active-questionnaires-by-itemcode", data);
};
const createQuestionnaireResponse = (data) => {
  return http.post("/api/create-questionnaire-response", data);
};
const createEnquiry = (data) => {
  return http.post("/api/create-enquiry", data);
};
const getActiveCategory = () => {
  return http.get("/api/get-active-category");
};
const getActiveGroup = (data) => {
  return http.post("/api/get-active-group", data);
};
const getImagebyCategory = (data) => {
  return http.post("/api/get-image-by-category", data);
};
const getActiveCategoryAll = () => {
  return http.get("/api/get-all-active-category");
};

const getGroupCode = () => {
  return http.post("/api/get-group-code");
};

const getGroupFor3dModel = (data) => {
  return http.post("/api/get-group-code-for-3d", data);
};

const getAllPractitioners = (data) => {
  return http.post("/api/doctor-schedule/getPractitioners", data);
};

const getDoctorAvailableDays = (data) => {
  return http.post("/api/doctor-schedule/getDoctorAvailableDays", data);
};

const getDoctorSlots = (data) => {
  return http.post("/api/doctor-schedule/getDoctorSlots", data);
};

const guestAppointment = (data) => {
    return http.post("/api/guest-appointment", data);
  };

  const getDoctorAvailableDaysOnline = (data) => {
    return http.post("/api/doctor-schedule/getDoctorAvailableDays/online", data);
  };

const config = {
  login,
  getActiveQuestionnairesByItemId,
  getActiveQuestionnairesByItemCode,
  createQuestionnaireResponse,
  createEnquiry,
  getActiveCategory,
  getActiveGroup,
  getImagebyCategory,
  getActiveCategoryAll,
  getGroupCode,
  getGroupFor3dModel,
  getAllPractitioners,
  getDoctorAvailableDays,
  getDoctorSlots,
  guestAppointment,
  getDoctorAvailableDaysOnline,
};

export default config;
//#endregion
